const Request = require('@/repositories/request')

class MagicLinkInvitations extends Request {
  async sendMagicLinkInvitation(userId, contactMethod, contactMethodType) {
    return await this.$strapi.$http.$post(
      '/magic-link-invitations/send-magic-link-invitation',
      {
        userId,
        contactMethod,
        contactMethodType,
      }
    )
  }

  async verifyMagicLinkToken(token) {
    return await this.$strapi.$http.$post(
      '/magic-link-invitations/verify-magic-link-token',
      {
        token,
      }
    )
  }
}

module.exports = MagicLinkInvitations
